module.exports = __webpack_public_path__ + "img/SteelLogo_BW.30789384.jpg";